import { asScoreMetadata } from '@arcxmoney/arcx-core';
import { asArray, asObject, asOptional, asString } from '@restless/sanitizers';
export var asFullScore = asObject({
    account: asString,
    protocol: asString,
    score: asString,
    metadata: asScoreMetadata,
    merkleProof: asOptional(asArray(asString)),
});
//# sourceMappingURL=fullScore.js.map